exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".counter-marker__container{display:flex;align-items:stretch;height:250px}.mark-group{display:flex;justify-content:space-between;flex-direction:column;cursor:pointer}@media (max-width:990px){.mark-group{cursor:auto}}@media (max-width:990px){.counter-marker__container{align-items:stretch;height:auto;flex-direction:row;flex-wrap:wrap}.counter-marker__container>*{flex-grow:1;flex-basis:100%}.mark-group{flex-direction:row;order:2}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f84e7b8","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CounterMarks/CounterMarks.vue
// module id = 67
// module chunks = 0